import { render, staticRenderFns } from "./RoadLawArticle24.vue?vue&type=template&id=77a767a5&"
import script from "./RoadLawArticle24.vue?vue&type=script&lang=js&"
export * from "./RoadLawArticle24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports